import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  AccountingsQueryFilters,
  MultiBookingReportCommand,
  PreSellStatsCommand,
  SellStatsCommand,
} from '../../features/accountings/accountingSlice';

export function updateSellAccountingGroup(accountingGroup) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accountings/accounting/updatesellaccountinggroup',
      accountingGroup,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function addSellAccountingGroup(accountingGroup) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accountings/accounting/addsellaccountinggroup',
      accountingGroup,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updatePurchaseAccountingGroup(accountingGroup) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accountings/accounting/updatepurchaseaccountinggroup',
      accountingGroup,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function addPurchaseAccountingGroup(accountingGroup) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accountings/accounting/addpurchaseaccountinggroup',
      accountingGroup,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateSellVat(sellVat) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/accountings/accounting/updatesellvat', sellVat, config)
    .then(res => {
      return res.data;
    });
}

export function generateSellStats(commanad: SellStatsCommand) {
  // const config = {
  //   headers: apiRequestHeaders.csrfHeader(),
  //   responseType: 'blob',
  // };

  return axios
    .post('/accountings/accounting/generatesellstats', commanad, {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      responseType: 'blob',
      timeout: 0,
    })
    .then(res => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Myyntikirja.xlsx'); // Set the file name
      link.click();
      link.remove();
      return res.data;
    });
}
export function generateMultiBookingReport(
  commanad: MultiBookingReportCommand,
) {
  // const config = {
  //   headers: apiRequestHeaders.csrfHeader(),
  //   responseType: 'blob',
  // };

  return axios
    .post('/accountings/accounting/generatemultibookingreport', commanad, {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      responseType: 'blob',
    })
    .then(res => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'KooontiRaportti.xlsx'); // Set the file name
      link.click();
      link.remove();
      return res.data;
    });
}

export function generatePreSellStats(commanad: PreSellStatsCommand) {
  // const config = {
  //   headers: apiRequestHeaders.csrfHeader(),
  //   responseType: 'blob',
  // };

  return axios
    .post('/accountings/accounting/generatepresellstats', commanad, {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      responseType: 'blob',
      timeout: 0,
    })
    .then(res => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Ennakkomyyntikirja.xlsx'); // Set the file name
      link.click();
      link.remove();
      return res.data;
    });
}

export function updatePurchaseVat(purchaseVat) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/accountings/accounting/updatepurchasevat', purchaseVat, config)
    .then(res => {
      return res.data;
    });
}

export function fetchAllSellVats(filterRequest: AccountingsQueryFilters) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };
  return axios
    .post('/accountings/accounting/getallsellvats', filterRequest, config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllPurchaseVats(filterRequest: AccountingsQueryFilters) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post('/accountings/accounting/getallpurchasevats', filterRequest, config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllSellAccountingGroups(
  filterRequest: AccountingsQueryFilters,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post(
      '/accountings/accounting/getallsellaccountinggroups',
      filterRequest,
      config,
    )
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllPurchaseAccountingGroups(
  filterRequest: AccountingsQueryFilters,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post(
      '/accountings/accounting/getallpurchaseaccountinggroups',
      filterRequest,
      config,
    )
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}
